import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSubscriptions = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M10.5 4A1.5 1.5 0 0 1 12 2.5h7A2.5 2.5 0 0 1 21.5 5v7c0 .04-.002.082-.005.122a7.649 7.649 0 0 0-1.995-.527V6A1.5 1.5 0 0 0 18 4.5h-7.2a.3.3 0 0 1-.3-.3V4Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M17.5 11.518V9A2.5 2.5 0 0 0 15 6.5H8A1.5 1.5 0 0 0 6.5 8v.2a.3.3 0 0 0 .3.3H14a1.5 1.5 0 0 1 1.5 1.5v1.967a6.807 6.807 0 0 1 2-.45Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M13.5 13.18V12a1.5 1.5 0 0 0-1.5-1.5H4A1.5 1.5 0 0 0 2.5 12v8A1.5 1.5 0 0 0 4 21.5h7.346c-.254-.834-.378-1.826-.346-3 .083-2.129 1.025-4.036 2.5-5.32Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M16.684 16.331a2.125 2.125 0 0 1 2.818.166l.354.354-.772.772a.25.25 0 0 0 .154.425l2.88.262a.4.4 0 0 0 .434-.434l-.261-2.88a.25.25 0 0 0-.426-.154l-.772.771-.353-.353a3.875 3.875 0 0 0-5.298-.171.238.238 0 0 0-.005.348l.883.884a.276.276 0 0 0 .364.01Zm2.632 3.338a2.125 2.125 0 0 1-2.819-.166l-.353-.354.771-.772a.25.25 0 0 0-.154-.425l-2.88-.262a.4.4 0 0 0-.434.434l.262 2.88a.25.25 0 0 0 .425.154l.772-.771.354.353a3.875 3.875 0 0 0 5.297.171.238.238 0 0 0 .006-.348l-.884-.884a.274.274 0 0 0-.363-.01Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcSubscriptions");

export { IcSubscriptions };
//# sourceMappingURL=ic-subscriptions.js.map
